module.exports = __webpack_public_path__ + "public/images/partners/sup-5.75e97d9168bfb2dab577576ecec6eae8.png";